import React, { useRef, useState } from 'react';
import ModalVideoUserResponse from '../../UI/Modal/ModalVideoUserResponse';
import Loader from '../../UI/Loader';

function VideoUserResponse(props) {

    const { videoSrc, modalResponse, modalPrizeTitle } = props;
    const videoRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const handleVideoLoaded = () => {
        setLoading(false);
    };

    const handleVideoEnded = () => {
        // disabled modal after video
        // setTimeout(() => {
        //     setShowModal(true);
        // }, 1000);
    };

    const handleModal = () => {
        setShowModal(!showModal);
    }

    return (
        <>
            {loading && <Loader />}
            <video ref={videoRef} autoPlay muted playsInline onLoadedData={handleVideoLoaded} onEnded={handleVideoEnded}>
                <source src={videoSrc} type="video/mp4" />
            </video>

            {showModal && <ModalVideoUserResponse handleModal={handleModal} modalResponse={modalResponse} modalPrizeTitle={modalPrizeTitle} />}
        </>
    );
}

export default VideoUserResponse;